import { Link } from "react-router-dom";

const HEADERS = [
  "Vendor",
  "Vendor Country",
  "Service",
  "Language Pair",
  "Specialization",
  "Currency",
  "Unit",
  "Price/Unit",
];

const vendorCode = (id) => (id ? `VDR-${String(id).padStart(3, "0")}` : "—");

const AllPricesTable = ({ data = [] }) => {
  return (
    <div className="w-full bg-white shadow rounded-lg overflow-hidden">
      <div className="max-h-[600px] overflow-y-auto overflow-x-auto">
        <table className="w-full table-auto border-collapse min-w-[1100px]">
          <thead className="sticky top-0 z-10">
            <tr className="bg-white border-b text-[10px] tracking-widest text-gray-500 uppercase">
              {HEADERS.map((h) => (
                <th
                  key={h}
                  className="px-3 py-2 text-center font-semibold whitespace-nowrap"
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td
                  colSpan={HEADERS.length}
                  className="py-10 text-center text-gray-400 text-xs"
                >
                  No price list found.
                </td>
              </tr>
            ) : (
              data.map((item, index) => {
                const rowBg = index % 2 === 0 ? "bg-gray-50" : "bg-white";
                const vendorId = item.vendor?.id || item.vendor_id;
                const langPair =
                  item.languagePair?.sourceLanguage &&
                  item.languagePair?.targetLanguage
                    ? `${item.languagePair.sourceLanguage.code} → ${item.languagePair.targetLanguage.code}`
                    : "—";
                return (
                  <tr
                    key={item.id}
                    className={`${rowBg} hover:bg-blue-50 transition-colors`}
                  >
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center font-medium">
                      {vendorId ? (
                        <Link
                          to={`/vendors/${vendorId}`}
                          className="text-blue-600 hover:text-blue-800 underline"
                        >
                          {vendorCode(vendorId)}
                        </Link>
                      ) : (
                        "—"
                      )}
                    </td>
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-700">
                      {item.vendor?.country || "—"}
                    </td>
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-900">
                      {item.service?.name || "—"}
                    </td>
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-700">
                      {langPair}
                    </td>
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-700">
                      {item.specialization?.name || "—"}
                    </td>
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-700">
                      {item.currency?.currency?.code || "—"}
                    </td>
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-700">
                      {item.unit || "—"}
                    </td>
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-900 font-medium">
                      {item.price_per_unit ?? "—"}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AllPricesTable;
